// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__-hash--base64-5-","Open":"SideDrawer__Open__-hash--base64-5-","Close":"SideDrawer__Close__-hash--base64-5-","Logo":"SideDrawer__Logo__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 69
// module chunks = 0